import { z } from "zod";
import { Time } from "@internationalized/date";
import { isBefore } from "date-fns";
import { applyTimeToDate } from "@ac-expo/utils";

export const ticketingOnlineConfigSchema = z
  .object({
    id: z.string().optional(),
    availabilityStartingDate: z
      .date()
      .refine(
        (date) => !isNaN(date.getTime()),
        "Date de début de validité invalide"
      )
      .nullable(),
    availabilityEndingDate: z
      .date()
      .refine(
        (date) => !isNaN(date.getTime()),
        "Date de fin de validité invalide"
      )
      .nullable(),
    availabilityStartingTime: z.instanceof(Time).nullish(),
    availabilityEndingTime: z.instanceof(Time).nullish(),
  })
  .refine(
    ({ availabilityStartingDate, availabilityStartingTime }) =>
      (availabilityStartingDate && availabilityStartingTime) ||
      (!availabilityStartingDate && !availabilityStartingTime),
    {
      message: "La date et l'heure doivent être renseignées ensemble",
      path: ["availabilityStartingDate"],
    }
  )
  .refine(
    ({ availabilityEndingDate, availabilityEndingTime }) =>
      (availabilityEndingDate && availabilityEndingTime) ||
      (!availabilityEndingDate && !availabilityEndingTime),
    {
      message: "La date et l'heure doivent être renseignées ensemble",
      path: ["availabilityEndingDate"],
    }
  )
  .refine(
    ({
      availabilityStartingDate,
      availabilityEndingDate,
      availabilityStartingTime,
      availabilityEndingTime,
    }) =>
      availabilityStartingDate &&
      availabilityStartingTime &&
      (!availabilityEndingDate ||
        !availabilityEndingTime ||
        isBefore(
          applyTimeToDate(availabilityStartingDate, availabilityStartingTime),
          applyTimeToDate(availabilityEndingDate, availabilityEndingTime)
        )),
    {
      message: "La date de début doit être antérieure à la date de fin",
      path: ["availabilityStartingDate"],
    }
  );

export const defaultTicketingOnlineConfigValues = {
  availabilityStartingDate: null,
  availabilityEndingDate: null,
  availabilityStartingTime: null,
  availabilityEndingTime: null,
};

export type TicketingOnlineConfigForm = z.infer<
  typeof ticketingOnlineConfigSchema
>;
